import axios from '@/backend'

const state = {
  board: {}
}

const getters = {
  currentBoard (state) {
    return state.board
  }
}

const mutations = {
  setCurrentBoard (state, board) {
    state.board = board
  }
}

const actions = {
  loadBoard ({dispatch, commit}, boardId) {
    axios.get('/boards/' + boardId).then(function (response) {
      commit('setCurrentBoard', response.data)
    })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/boards.js